import { css } from '@emotion/react';

export const errorPage = css`
  width: 100%;
  height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr;
  padding: 16px 24px;
`;

export const content = css`
  max-width: 600px;
  margin: 200px auto;
`;

export const customLogo = css`
  min-height: 25px;
  max-height: 27px;

  max-width: 600px;
`;
